{
    "Profile_BoundPolicyNotice.header": "FR: Bound policy: limited editing",
    "Profile_BoundPolicyNotice.body": "FR: This policy is bound. As an administrator you can correct its details, but the selected quote cannot change.",
    "Profile_BoundPolicyNotice.locked": "FR: Locked: {fields}.",
    "Profile_BoundPolicyNotice.documents": "FR: After a change, regenerate the affected documents from the Documents tab.",
    "Profile_BoundPolicyNotice.field.riskAddress": "FR: property address",
    "Profile_BoundPolicyNotice.field.saleAmount": "FR: sale price",
    "Profile_BoundPolicyNotice.field.propertySaleStatus": "FR: sale status",
    "Profile_BoundPolicyNotice.field.unknown": "{code}"
}
